<template>
    <app-table
        deletable
        :data="items"
        :highlight-rows-on-hover="true"
        @deleteRow="deleteItem"
    >
        <template slot="secondary_header">
            <div class="status search" style="min-height: 1px !important;" />
            <form class="filter expand_content open" @submit.prevent="submitForm">
                <div class="field_left">
                    <app-input
                        id="newSourceLanguage"
                        name="language"
                        :label="$gettext('Jazyk')"
                        v-model="newInstance.language"
                    />
                </div>

                <div class="field_left">
                    <app-input
                        id="newSourceUrl"
                        :label="$gettext('Url')"
                        v-model="newInstance.url"
                    />
                </div>

                <div class="field_right">
                    <app-content-save-button />
                </div>
            </form>
        </template>
        <app-table-column first attribute="language" :label="$gettext('Jazyk')" />
        <app-table-column attribute="url" :label="$gettext('URL obsahu')" />
    </app-table>
</template>

<script>
import {mapActions} from "vuex";

export default {
    name: "contentUri",
    data() {
        return {
            newInstance: this.createNewInstance(),
            items: this.item[this.type] || [],
        }
    },
    props: {
        item: {
            type: Object,
            default: null,
        },
        type: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: null,
        }
    },
    methods: {
        ...mapActions([
            'updateVideoContent',
        ]),
        deleteItem(itemToDelete) {
            this.items = this.items.filter((item) => item !== itemToDelete);
            this.item[this.type] = this.items;

            this.updateEntity();
        },
        createNewInstance() {
            return {
                language: '',
                url: '',
            }
        },
        submitForm(evt) {
            this.newInstance.url = this.newInstance.url.trim();
            this.newInstance.language = this.newInstance.language.trim();

            if (!this.newInstance.url || !this.newInstance.language) {
                return false;
            }
            
            if(!this.items) {
                this.items = [this.newInstance];
            } else {
                this.items.push(this.newInstance);
            }

            this.item[this.type] = this.items;
            this.newInstance = this.createNewInstance();

            this.updateEntity();
        },
        updateEntity() {
            this.updateVideoContent({
                params: {
                    id: this.item._id,
                },
                data: {
                    content: this.items,
                    type: this.type
                }
            });
        }
    }
}
</script>

